import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import Icon from '@gcloud-npm/next12.components.icon-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SEGMENT } from './utils.js';

const ModalAtencionEmp = dynamic(() =>
  import('@/components/modal-atencion-emp')
);

export const C2C_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
  CORAL: 'coral',
  AMBAR: 'ambar',
  GrEY2: 'grey2',
};

export const COMPONENT_NAME = 'ContactCircle';

const StyleFlotante = styled.div`
  @media screen and (min-width: 769px) {
    .clickToCall {
      bottom: ${(props) =>
        props.bottomDistanceDesktop
          ? `${props.bottomDistanceDesktop}px`
          : '107px'} !important;
      width: 165px !important;
    }
    .flotante-txt {
      display: block !important;
    }
  }
  .clickToCall {
    position: fixed;
    width: 60px;
    height: 40px;
    display: flex;
    right: 0;
    z-index: 10;
    border-radius: 90px 0px 0px 90px;
    box-shadow: 0px 3px 6px #00000029;
    padding: 6px;
    bottom: ${(props) =>
      props.bottomDistanceMobile ? `${props.bottomDistanceMobile}px` : '75px'};
    .flotante-txt {
      display: none;
    }
    &-text {
      margin-left: 8px;
    }
    &-cheuron {
      margin-left: 10px;
    }
    &_white {
      background-color: var(--color-emp--white);
    }
    &_coral {
      background-color: var(--color-emp--coral);
    }
    &_black {
      background-color: var(--color-emp--black);
    }
    &_ambar {
      background-color: var(--color-emp--ambar);
    }
    &_grey2 {
      background-color: var(--color-emp--grey2);
    }
    &_Icon {
      width: 64px;
      height: 64px;
      border-radius: 90px 90px 90px 90px;
      display: inline-grid;

      &_white {
        background-color: var(--color-emp--white);
      }
      &_coral {
        background-color: var(--color-emp--coral);
      }
      &_black {
        background-color: var(--color-emp--black);
      }
      &_ambar {
        background-color: var(--color-emp--ambar);
      }
    }
    .transparent-background {
      background-color: transparent !important;
      display: flex;
      margin-left: 7px;
      align-items: center;
      width: 100%;
      justify-content: space-between;
    }
    .svgIL {
      display: flex;
    }
    .svgIL_row-direction .svgIL_label {
      margin-left: 8px;
    }
  }
`;

const Flotante = (props) => {
  const { flotanteProps, visible, product } = props;
  const { data } = useSelector((state) => state.constants);
  let { taggingInfo } = props;

  const {
    iconId,
    iconSize,
    iconSegment,
    iconKind,
    iconColor,
    labelColor,
    labelText,
    backgroundColor,
    desktopContainerBottom,
    mobileContainerBottom,
    title,
    option,
  } = flotanteProps;

  if (!taggingInfo) {
    taggingInfo = {
      componentVariation: flotanteProps.campaign || 'all',
      componentName: COMPONENT_NAME,
      componentProduct: '',
    };
  }

  const containerRootClass = 'clickToCall';

  const dispatch = useDispatch();

  const handleModal = ({ item, productModal }) => {
    const MODAL_PROPS = {
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    };
    dispatch(
      modalActions.addModal({
        id: 'atencionModal',
        type: 'MODAL',
        elementProps: {
          tabsOptions: {
            ...data.modalAtencionConfig,
            tabOptionPreChecked: 'te-llamamos',
          },
          product: productModal,
          campaign: item.campaign,
          taggingInfo: {
            ...taggingInfo,
          },
        },
        Element2Show: ModalAtencionEmp,
        modalProps: MODAL_PROPS,
      })
    );
  };

  const generateClassNameWithColor = (
    className,
    color,
    defaultColor = C2C_COLORS.WHITE
  ) => {
    let classColor = defaultColor;
    const colorExist = Object.values(C2C_COLORS).find((c) => c === color);

    if (colorExist) {
      classColor = colorExist;
    }

    return `${className} ${className}_${classColor}`;
  };

  const componentContainerClass = useMemo(
    () =>
      generateClassNameWithColor(
        containerRootClass,
        backgroundColor,
        C2C_COLORS.CORAL
      ),
    [backgroundColor]
  );

  const renderLinkWithModal = () => {
    return (
      <span className="transparent-background">
        <Icon
          segment={iconSegment}
          id={iconId}
          kind={iconKind}
          size={iconSize}
          color={iconColor}
        />
        <TextInfo
          kind="span"
          size="caption01"
          text={labelText}
          fontType="font-regular"
          color={labelColor}
          segment={iconSegment}
          className="flotante-txt"
        />
        <TextInfo />
        <Icon
          segment={iconSegment}
          id="CheuronRight"
          kind="M"
          size={16}
          color={iconColor}
          className="flotante-cheuron"
        />
      </span>
    );
  };

  if (!visible) {
    return null;
  }

  return (
    <StyleFlotante
      bottomDistanceDesktop={desktopContainerBottom}
      bottomDistanceMobile={mobileContainerBottom}
    >
      <div className={componentContainerClass}>
        {renderLinkWithModal()}
        <CustomLink
          isBlockElement
          onClick={() => {
            handleModal({
              item: flotanteProps,
              productModal: product,
            });
          }}
          accInfo={{ title: title || 'Te asesoramos' }}
          taggingInfo={{
            ...taggingInfo,
            componentContent: title || option,
            componentVariation: flotanteProps.campaign || 'all',
          }}
        />
      </div>
    </StyleFlotante>
  );
};

Flotante.defaultProps = {
  visible: true,
  segment: SEGMENT.EMP,
  flotanteProps: {
    iconId: 'Fijo',
    iconKind: 'M',
    iconSize: 31,
    iconColor: 'grey6',
    iconSegment: 'emp',
    desktopContainerTop: 418,
    mobileContainerTop: 256,
    desktopContainerBottom: 107,
    mobileContainerBottom: 75,
    backgroundColor: 'ambar',
    title: 'Te asesoramos',
  },
};

Flotante.propTypes = {
  /**
   * {
   *  "info": "Segmento para definir carta de colores correspondiente",
   *  "kind": "both",
   *  "beautifulName": "segment"
   * }
   */
  segment: PropTypes.oneOf([SEGMENT.GP, SEGMENT.EMP]),
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: PropTypes.string,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: PropTypes.object,
  /**
   * {
   *  "info": "Visibiliza el componente",
   *  "kind": "both",
   *  "beautifulName": "Visible"
   * }
   */
  visible: PropTypes.bool,
  flotanteProps: PropTypes.shape({
    iconId: PropTypes.string.isRequired,
    iconKind: PropTypes.string.isRequired,
    iconSize: PropTypes.number.isRequired,
    iconColor: PropTypes.string.isRequired,
    iconSegment: PropTypes.oneOf(SEGMENT).isRequired,
    desktopContainerTop: PropTypes.number.isRequired,
    mobileContainerTop: PropTypes.number.isRequired,
    desktopContainerBottom: PropTypes.number.isRequired,
    mobileContainerBottom: PropTypes.number.isRequired,
    iconContainerColor: PropTypes.oneOf(C2C_COLORS).isRequired,
    backgroundColor: PropTypes.oneOf(C2C_COLORS).isRequired,
    title: PropTypes.string.isRequired,
  }),
  Modal: PropTypes.func.isRequired,
  // Para cambiarle el producto que enviara el formulario
  fixedProduct: PropTypes.string,
  // Para setearle una campaña al formulario distinta de la que pueda dar SCX
  fixedCampaign: PropTypes.string,
};

export default Flotante;
